import "./style.css";
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
export default function Footer() {
  const theme = createTheme({
    palette: {
      primary: {
         
              main: '#FFCD00',
              dark: '#ffcd38',
              contrastText: '#000',
        
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
    <div className="footer">
     
      
    <div className="foot">
        <div className="footLink">
       <ol>
       <li><a href="/">Acceuil</a></li>
       <li><a href="/projets">projets</a></li>
        <li><a href="/blog">blog</a></li>
        <li> <a  href="mailto:hossjanfaoui.dev@gmail.com" > demander devis</a> </li>
     
       </ol>
      </div>
      </div>
      <div className="footBottom">
        <h5 style={{ color: "GrayText" }}>
          © 2021 H4CODE, All Rights Reserved.
        </h5>
      </div>
    
    
    </div>
    </ThemeProvider>
  );
}
